/** @param {Array} array */
export const checkIsOne = (array) =>{
   return array.length === 1;
}